import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C5TimeSeriesEdit } from "./edit";
import { C5TimeSeriesNew } from "./new";
import { C5TimeSeriesTable } from "./table";

export default function C5TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C5TimeSeriesEdit />} />
      <Route index element={<C5TimeSeriesTable />} />
      <Route path="/new" element={<C5TimeSeriesNew />} />
    </Routes>
  );
}
